import styled, { css } from 'styled-components';

export const PortfolioDiv = styled.section`
  position: relative;
`;

export const PortfolioLightBox = styled.section`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 80px;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  z-index: 3;
  background-color: rgba(0,0,0,0.8); 

  .navigation {
    overflow-y: scroll;
    width: 85%;
    height: 100%;
    max-width: 1000px;
    scrollbar-width: thin;          
    scrollbar-color: #034063 #02283c;

    &::-webkit-scrollbar {
  width: 9px;
  }

&::-webkit-scrollbar-track {
  background: #02283c;
}

&::-webkit-scrollbar-thumb {
  background: #034063;
  border-radius: 20px;
  border: 1px solid #fff;
}
  }

  span {
    color: #fff;
    float: right;
    font-size: 3rem;
    cursor: pointer;
    position absolute;
    z-index: 3;
    top: 3rem;
    right: 3rem;
    &:hover {
      filter: invert(68%) sepia(73%) saturate(411%) hue-rotate(138deg)
        brightness(91%) contrast(95%);
    }
  }

  .modal-content {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
    clear: both;
    z-index: 5;
  }
  .arrow-right,
  .arrow-left {
    width: 3rem;
    position: absolute;
    filter: invert(57%) sepia(7%) saturate(8%) hue-rotate(131deg)
      brightness(96%) contrast(90%);
    cursor: pointer;

    &:hover {
      filter: invert(68%) sepia(73%) saturate(411%) hue-rotate(138deg)
        brightness(91%) contrast(95%);
    }
  }
  .arrow-right {
    top: calc(50% - 40px);
    right: 0;
    margin-right: 3rem;
  }
  .arrow-left {
    top: calc(50% - 40px);
    left: 0;
    margin-left: 3rem;
  }
`;

export const PortfolioSection = styled.section`
  height: 100%;
  position: relative;
  overflow: hidden;
  width: 100%;
  will-change: contents;
  min-height: 566px;
  z-index: 1;
  transform-style: preserve-3d;
  animation: fadeIn 1s forwards;
  animation-delay: 2.5s;
  opacity: 0;
  background-color: #02283c;

  ${({ sideBar }) =>
    sideBar &&
    css`
      filter: blur(4px);
    `}

  .project-div {
    padding: 5rem 4rem;
    margin-left: 9rem;
    display: grid;
    grid-template-columns: 1fr;
    gap: 6rem;

    position: relative;
    width: calc(100% - 9rem);

    @media (max-width: 1100px) {
      padding: 3rem;
      padding-bottom: 5rem;
    }

    @media (max-width: 900px) {
      width: 100%;
      margin-left: 0;
      padding: 5rem 2rem;
    }
    @media (max-width: 700px) {
      padding: 6rem 2rem;
    }
    @media (max-width: 500px) {
      gap: 5rem;
    }
    @media (max-width: 380px) {
      padding: 4rem 1.4rem;
    }
  }
`;

export const ProjectDiv = styled.section`
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  border-radius: 0.4rem;
  background-color: #034063;
  opacity: 0.8;
  color: #fff;
  padding: unset;
  animation: pulse;
  animation-duration: 0.45s;
  animation-delay: 1.2s;
  animation-fill-mode: both;
  animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);

  .project-img {
    position: relative;
    height: 12rem;
    padding: unset;
    overflow: hidden;
    border-top-right-radius: 0.4rem;
    border-top-left-radius: 0.4rem;

    img {
      transition: all ease-in 0.4s;
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: relative;
      border-top-right-radius: 0.4rem;
      border-top-left-radius: 0.4rem;
    }

    .project-overlay {
      position: absolute;
      transition: background-color linear 0.4s;
      transition: opacity linear 0.4s;
      width: 100%;
      height: 100%;
      top: 0;
      background-color: #011a28;
      // background-color: black;
      opacity: 0.6;
      display: flex;
      align-items: center;
      justify-content: center;

      .view {
        background-color: #3bcfe3;
        transition: display fade 1s;
        transition: transform fade 1s;
        transition-delay: 2s;
        width: 5rem;
        height: 5rem;
        border-radius: 50%;
        text-align: center;
        display: none;
        cursor: pointer;
        font-size: 0.8rem;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        img {
          width: 1rem;
          height: 0.8rem;
          filter: invert(100%) sepia(100%) saturate(2%) hue-rotate(265deg)
            brightness(105%) contrast(100%);
          margin-top: 0.4rem;
        }
        p {
          margin-top: 0.2rem;
        }
      }
    }
  }

  &:hover .project-img .project-overlay {
    background-color: transparent;
    opacity: 1;
  }

  &:hover .project-img img {
    transform: scale(1.1);
  }

  &:hover .project-img .project-overlay .view {
    display: flex;
    transform: scale(1);
  }

  .project-desc {
    padding: 1rem;
    padding-bottom: 0;

    h3 {
      font-size: 1rem;
      color: #3bcfe3;
      cursor: pointer;
      display: inline-block;
      &:hover {
        text-decoration: underline;
        opacity: 0.8;
      }
    }
    a {
      filter: invert(68%) sepia(73%) saturate(411%) hue-rotate(138deg)
        brightness(91%) contrast(95%);
      font-weight: bold;
      text-decoration: none;
      &:hover {
        opacity: 0.8;
      }
    }
    .tech-stack {
      font-size: 0.8rem;
      font-weight: bold;
      margin: 0.5rem 0;

      * + * {
        margin-left: 0.5rem;
      }

      span {
        color: yellow;
      }
    }
    p {
      font-size: 0.84rem;
      font-weight: 400;
    }
  }
  .project-links {
    display: flex;
    justify-content: space-between;
    padding: 1rem;
    align-items: center;
    img {
      width: 1.2rem;
      filter: invert(57%) sepia(7%) saturate(8%) hue-rotate(131deg)
        brightness(96%) contrast(90%);
      cursor: pointer;
      &:hover {
        filter: invert(68%) sepia(73%) saturate(411%) hue-rotate(138deg)
          brightness(91%) contrast(95%);
      }
    }
  }
`;
